export const EventStates = {
    EVENT_TAB: 'EVENT_TAB',
    EVENT_TAB_ROUTE: 'EVENT_TAB_ROUTE'
};

export const EventActions = {
    EVENT_TAB_CHANGE: 'EVENT_TAB_CHANGE',
    EVENT_TAB_CHANGE_ROUTE: 'EVENT_TAB_CHANGE_ROUTE'
};
